<template>
    <span class="ath-visual-trend" :class="[cname]"></span>
</template>

<script>
export default {
    name: 'mead-trend',
    props: {
        /**
         * The trend value used to determine the arrow direction: positive values
         * point up, negative values point down, and 0 renders a flat/neutral
         * indicator.
         */
        value   : {type: Number, default: () => 0},
        /**
         * Colorize value (0 = not, 1 = standard, -1 = inverse). With standard
         * colorizing, positive values are colored as positive; with inverse,
         * the color meaning is flipped (useful for metrics where a decrease is good).
         */
        colorize: {type: Number, default: () => 1},
    },
    computed: {
        cname: function () {
            if (this.value === 0) return 'el--t-neutral';
            return this.colorize === -1
                ? this.value > 0 ? 'el--t-negative' : 'el--t-positive'
                : this.value > 0 ? 'el--t-positive' : 'el--t-negative';
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/_variables.scss';

.ath-visual-trend {
    display: inline-block;
    width: 0;
    height: 0;
    border-radius: 2px;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;

    &.el--t-neutral {
        border-left: none;
        border-right: none;
        height: 8px;
        width: 10px;
        position: relative;

        &:before {
            content: '';
            display: inline-block;
            position: absolute;
            top: 2px;
            bottom: 2px;
            left: 0;
            right: 0;
            border-radius: 2px;
            background-color: var(--c-sentiment-neutral-bg);
        }
    }

    &.el--t-positive {
        border-bottom: 8px solid var(--c-sentiment-positive-bg);
    }

    &.el--t-negative {
        border-top: 8px solid var(--c-sentiment-negative-bg);
    }
}
</style>
